import { User } from './user'

export interface Profile {
    username: string;
    displayName: string;
    image?: string;
    coverImageUrl?: string;
    bio?: string;
    photos?: Photo[];
    followersCount?: number;
    followingCount?: number;
    isFollowing?: boolean;
    ammoScore?: number;
    ammoTier?: string;
    totalVotesReceived?: number;
    approvedSubmissionsCount?: number;
    postCount?: number;
    buildCount?: number;
    wishlistCount?: number;
    isVaultPublic?: boolean;
    /** When false, other users cannot see this member's wishlist. */
    isWishlistPublic?: boolean;
}

export function profileFromUser (user: User): Profile {
  return { username: user.username, displayName: user.displayName, image: user.image }
}

export interface Photo {
    id:string;
    url: string;
    isMain: boolean;
}

export interface ProfileActivityItemDto {
    id: string;
    action: string;
    detail: string;
    createdAt: string;
    scoreDelta: number | null;
}
